import { editProject, updateBillingTier } from '~/api/projects2';
import type { Project } from '~/common/types';

type UpgradeBillingTierParams = {
  projectId: string;
  tier: Parameters<typeof updateBillingTier>[1];
  costInfo: Parameters<typeof updateBillingTier>[2];
  attributes: { [key: string]: any };
};

export type UpgradeBillingTierResult = { editsSaved: boolean; updatedProject: Project };

export async function upgradeBillingTierAndSaveEdits({
  projectId,
  tier,
  costInfo,
  attributes,
}: UpgradeBillingTierParams): Promise<UpgradeBillingTierResult> {
  const updatedProject = await updateBillingTier(projectId, tier, costInfo);

  const { billingTier: _billingTier, ...rest } = attributes;
  if (Object.keys(rest).length === 0) {
    return { editsSaved: true, updatedProject };
  }

  try {
    const updatedProject = await editProject(projectId, { attributes: rest });
    return { editsSaved: true, updatedProject };
  } catch {
    return { editsSaved: false, updatedProject };
  }
}
